module.exports = __webpack_public_path__ + "img/zsgscl-2.d3964454.jpg";